import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { handleGoogleAuthCallback } from '../../modules/auth/redux';
import LoadingSpinner from '../../lib/components/loadingSpinner';
import styled from 'styled-components';

const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: rgb(128, 83, 215);
`;

const ContentWrapper = styled.div`
  text-align: center;
  animation: fadeIn 0.5s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 600;
  margin-top: 30px;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 16px;
  opacity: 0.9;
  font-weight: 400;
`;

const GoogleCallback = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(handleGoogleAuthCallback(location.search));
  }, [dispatch, location]);

  return (
    <FullScreenContainer>
      <ContentWrapper>
        <LoadingSpinner />
        <Title>Authenticating with Google...</Title>
        <Description>Please wait while we redirect you.</Description>
      </ContentWrapper>
    </FullScreenContainer>
  );
};

export default GoogleCallback;
